module.exports = __webpack_public_path__ + "img/Warlock-bloodelf-m-70.cca8d465.gif";